/**
 * @file 推荐活动，登陆后才展示
 */
import { Modal } from '@bfe/moly';
import { useModal, useRefCode } from './hooks';
import { useQRCode } from '@/hooks/useQRCode';
import { useFm, useParams } from '@web3/base-hooks';
import { appPath } from '@web3/base-utils';

import styles from './index.module.less';
import { useEffect, useState } from 'react';
import { useHomeStore } from '@/store/home';
import { activityInfo } from '@/types';

const InviteIcon = `${appPath}/svg/home/invite.gif`;
const AppleIcon = `${appPath}/svg/home/invite-apple.svg`;
const AndoridIcon = `${appPath}/svg/home/invite-andorid.svg`;

export const InvateArea = () => {
  const { isShow, onOpenModal, onCloseModal } = useModal();
  const { refCode } = useRefCode();
  const { locale } = useParams();
  const [activityId, setActivityId] = useState(0);
  const fm = useFm();

  const store = useHomeStore();

  useEffect(() => {
    store.fetchFeaturedActivityList().then((res: any) => {
      if (res?.dataList.length) {
        const inviteActivity = res?.dataList?.filter(
          (item: activityInfo) => item.activityType === 3
        );
        if (inviteActivity?.length) {
          setActivityId(inviteActivity[0].activityId);
        }
      }
    });
  }, []);

  /* eslint-disable bybit/no-static-domain */
  const qrCodeUrl = `https://www.bybit.com/${locale}/web3/airdrop/hiddenquest?activityId=${activityId}&ref=${refCode}`;

  const { src } = useQRCode(qrCodeUrl, 200, 200);

  return activityId ? (
    <>
      {/* 活动icon */}
      <div className={styles.container} onClick={onOpenModal}>
        <img src={InviteIcon} alt="" />
        <div className={styles.text}>{fm('inviteToEarn')}</div>
      </div>
      {/* 弹窗区域 */}
      <Modal
        className={styles.modal}
        title={<div className={styles.title}>{fm('inviteToEarn')}</div>}
        open={isShow}
        footer={null}
        onCancel={onCloseModal}
      >
        <div className={styles.modalInner}>
          <div className={styles.desc}>
            {fm('inviteAppVersionTip', {
              version: '4.34.5',
            })}
          </div>
          <img className={styles.qrcode} src={src} alt="" />
          <div>
            <div
              className={styles.appleTipArea}
              onClick={() => {
                window.open(
                  'https://app.bybit.com/inapp?by_dp=bybitapp%3A%2F%2Fopen%2Froute%3FtargetUrl%3Dby%253A%252F%252Fweb3%252Ftab%252Findex%253Ftag%253Dear%26earnTab%253DairDrop&by_web_link=https%3A%2F%2Fwww.bybit.com%2Fen%2Fweb3%2Fairdrop'
                );
              }}
            >
              <div className={styles.iconArea}>
                <img src={AppleIcon} alt="" />
              </div>
              <div>
                <div className={styles.tipTitle}>
                  {fm('downloadForType', {
                    type: 'IOS',
                  })}
                </div>
                <div className={styles.tipDesc}>
                  {fm('getBybitAppFromType', {
                    type: 'App Store',
                  })}
                </div>
              </div>
            </div>
            <div
              className={styles.andoridTipArea}
              onClick={() => {
                window.open(
                  'https://app.bybit.com/inapp?by_dp=bybitapp%3A%2F%2Fopen%2Froute%3FtargetUrl%3Dby%253A%252F%252Fweb3%252Ftab%252Findex%253Ftag%253Dear%26earnTab%253DairDrop&by_web_link=https%3A%2F%2Fwww.bybit.com%2Fen%2Fweb3%2Fairdrop'
                );
              }}
            >
              <div className={styles.iconArea}>
                <img src={AndoridIcon} alt="" />
              </div>
              <div>
                <div className={styles.tipTitle}>
                  {fm('downloadForType', {
                    type: 'Android',
                  })}
                </div>
                <div className={styles.tipDesc}>
                  {fm('getBybitAppFromType', {
                    type: 'Google Play',
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  ) : null;
};
